// extracted by css-extract-rspack-plugin
export default {"HiddenHeading":"BoardHeadings-module__HiddenHeading__d9sWi"};